import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
import { isMobile } from "react-device-detect";

const ImageCarousel = () => {
  // Sample data - replace with your actual data
  const carouselItems = [
    {
      id: 1,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-choose.webp",
      keyword: "ecoshift",
    },
    {
      id: 2,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-choose-home.webp",
      keyword: "movement",
    },
    {
      id: 3,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-act.webp",
      keyword: "ecoresponsible",
    },
    {
      id: 4,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-act-home.webp",
      keyword: "ecopositive",
    },
    {
      id: 5,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-enjoy.webp",
      keyword: "ecofriendly",
    },
    {
      id: 6,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-enjoy-home.webp",
      keyword: "ecocentric",
    },
    {
      id: 7,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-enjoy-home7.webp",
      keyword: "enjoy",
    },
    {
      id: 8,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-enjoy-home8.webp",
      keyword: "ecoshift.eco",
    },
    {
      id: 9,
      imageUrl: "ecoshift-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-enjoy-home9.webp",
      keyword: "ecoshift platform",
    }
  ];

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 0 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 0 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 0 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const CarouselItem = ({ imageUrl, altText, index }) => {
    return (
      <div className="carousel-item-container"
      onClick={() => {
            setPhotoIndex(index);
            setIsOpen(true);
          }}>
        <div
          className="image-wrapper d-flex justify-content-center align-items-center">
          <img src={imageUrl} alt={altText} className="carousel-image" />
        </div>
      </div>
    );
  };

  return (
    <div className="carousel-wrapper">
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={false}
        containerClass="carousel-container"
        itemClass="carousel-item-padding-40-px"
        dotListClass="custom-dot-list"
        partialVisible={false}
        arrows={true}
        centerMode={true}
        showDots={true}
        additionalTransfrom={0}
      >
        {carouselItems.map((item) => (
          <CarouselItem
            key={item.id}
            imageUrl={`${process.env.PUBLIC_URL}/assets/images/gp_images/${item.imageUrl}`}
            altText={item.keyword}
            index={item.id - 1}
          />
        ))}
      </Carousel>
      {isOpen && (
        <Lightbox
          mainSrc={`${process.env.PUBLIC_URL}/assets/images/gp_images/${carouselItems[photoIndex].imageUrl}?v=${process.env.REACT_APP_IMAGE_VERSION}`}
          nextSrc={`${process.env.PUBLIC_URL}/assets/images/gp_images/${carouselItems[(photoIndex + 1) % carouselItems.length].imageUrl}?v=${process.env.REACT_APP_IMAGE_VERSION}`}
          prevSrc={`${process.env.PUBLIC_URL}/assets/images/gp_images/${carouselItems[(photoIndex + carouselItems.length - 1) % carouselItems.length].imageUrl}?v=${process.env.REACT_APP_IMAGE_VERSION}`} 
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + carouselItems.length - 1) % carouselItems.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % carouselItems.length)
          }
        />
      )}
    </div>
  );
};

export default ImageCarousel;
